import type { RouteObject } from 'react-router-dom';
import type { RouteHandle } from '@/layout/routeHandle';
import { ReportJobListPage } from './ReportJobListPage';

/** report-jobs（担当: G4）。S-96 帳票一括作成ジョブ（全ロール。基金は全件、他は自分の依頼） */
export const routes: RouteObject[] = [
  { path: 'report-jobs', element: <ReportJobListPage />, handle: { crumb: '帳票一括作成ジョブ' } satisfies RouteHandle },
];
